<header class="content-header">
  <h4 class="vision-h4">{{ data.protocol ? 'Edit Viewer Protocol' : 'Create New Viewer Protocol' }}</h4>
</header>

<div mat-dialog-content>
  <p class="subheader">
    Viewer protocols allow you to create custom workflows for capturing pertinent data from medical imaging inside the
    viewer. Design anything from a simple PHI review to a complex whole-body annotation study.
    <a href="https://docs.flywheel.io/?q=creating+viewer+protocol" target="_blank" test-id="view-docs-link"
      >View documentation</a
    >
  </p>
  <form [formGroup]="formGroup">
    <label aria-label="Protocol Name"> Protocol Name </label>
    <mat-form-field appearance="outline" class="full-width">
      <input formControlName="label" matInput placeholder="Enter protocol name" test-id="protocol-label-input" />
      @if (formGroup.controls.label.hasError('required')) {
        <mat-error>Protocol name required.</mat-error>
      }
      @if (formGroup.controls.label.hasError('duplicateLabel')) {
        <mat-error>A protocol with this name already exists.</mat-error>
      }
    </mat-form-field>

    <label aria-label="Protocol Description"> Protocol Description </label>
    <mat-form-field appearance="outline" class="full-width">
      <textarea
        formControlName="description"
        matInput
        placeholder="Enter a description..."
        rows="4"
        test-id="protocol-desc-input"
      ></textarea>
      @if (formGroup.controls.description.hasError('required')) {
        <mat-error>Description required.</mat-error>
      }
    </mat-form-field>

    <label aria-label="Viewer Form">
      Viewer Form
      <fw-icon
        class="xs"
        fwTooltip="Add or create JSON code related to the form questions the readers are presented in reader studies."
        >information-circle</fw-icon
      >
    </label>
    @if (formGroup.controls.form_id.value) {
      <div class="edit-resource">
        <span>ViewerForm.json</span>
        <button mat-icon-button test-id="edit-viewer-form-button" (click)="editResource('form')">
          <fw-icon>edit</fw-icon>
        </button>
      </div>
    }
    @if (!formGroup.controls.form_id.value) {
      <div class="upload-buttons">
        <button color="primary" mat-stroked-button test-id="open-editor-form-button" (click)="editResource('form')">
          Open Empty JSON Editor
        </button>
        <button color="primary" mat-stroked-button test-id="upload-form-button" (click)="formFileInput.click()">
          Upload JSON File
        </button>
        <input
          #formFileInput
          accept=".json"
          class="hidden"
          test-id="viewer-form-file-input"
          type="file"
          (change)="selectFile('form', $event)"
        />
      </div>
    }

    <label aria-label="Viewer Configuration">
      Viewer Configuration
      <fw-icon
        class="xs"
        fwTooltip="Add or create JSON code related to the look and feel of the viewer including general settings, toolbar, labels, layouts, and keyboard and mouse shortcuts."
      >
        information-circle
      </fw-icon>
    </label>
    @if (formGroup.controls.viewer_config_id.value) {
      <div class="edit-resource">
        <span>ViewerConfig.json</span>
        <button mat-icon-button test-id="edit-viewer-form-button" (click)="editResource('viewerConfig')">
          <fw-icon>edit</fw-icon>
        </button>
      </div>
    }
    @if (!formGroup.controls.viewer_config_id.value) {
      <div class="upload-buttons">
        <button
          color="primary"
          mat-stroked-button
          test-id="open-editor-config-button"
          (click)="editResource('viewerConfig')"
        >
          Open Empty JSON Editor
        </button>
        <button color="primary" mat-stroked-button test-id="upload-config-button" (click)="configFileInput.click()">
          Upload JSON File
        </button>
        <input
          #configFileInput
          accept=".json"
          class="hidden"
          test-id="viewer-config-file-input"
          type="file"
          (change)="selectFile('viewerConfig', $event)"
        />
      </div>
    }
  </form>
</div>

<div align="end" class="action-buttons" mat-dialog-actions>
  <button mat-stroked-button test-id="close-button" (click)="cancel()">Cancel</button>
  <button color="primary" mat-flat-button test-id="save-button" [disabled]="formGroup.invalid" (click)="submit()">
    Save
  </button>
</div>
